import React, { useEffect, useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import PanelTab from './PanelTab';
import './CustomTab.css'
import { useLocation } from 'react-router-dom';
import theme from 'config/theme';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const CustomTab = ({ base, panels, level }) => {
  const [value, setValue] = useState(0);
  const location = useLocation();
  panels = panels.filter(({ show = true }) => show);

  useEffect(() => {
    if (location.pathname === base) {
      if (panels[value] && typeof panels[value].onChange === 'function')
        setTimeout(() => {
          panels[value].onChange()
        }, 0);
    } else {
      let index = panels.findIndex(({ route }) => location.pathname == route)
      index = index === -1 ? panels.findIndex(({ route }) => location.pathname.includes(route)) : index
      setValue(index === -1 ? 0 : index)
    }
    // eslint-disable-next-line
  }, [location])

  const handlerChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Box >
      <Box sx={{
        marginLeft: '-16px',
        marginRight: '-16px',
      }}>
        <Tabs value={value || 0}
          variant={level ? "standard" : "fullWidth"}
          onChange={handlerChange}
          aria-label="basic tabs example"
          centered={level ? true : false}
          sx={{
            '&.MuiTabs-root': level ? {
              height: '40px',
              minHeight: '40px',
            } : { },
            '& .MuiTab-root': level ? {
              height: '40px',
              minHeight: '40px',
            } : { },
          }}
        >
          {
            panels.map(({ name, onChange }, i) => {
              return <Tab
                key={`tab_${i}`}
                label={name}
                onClick={onChange}
                className={`custom_tab ${level ? 'level' : ''}`}
                sx={{
                  textTransform: 'none',
                  // backgroundColor: theme.button.light.backgroundColor,
                  border: theme.button.dark.border,
                  color: theme.button.dark.border,
                  '&.Mui-selected': {
                    backgroundColor: theme.button.dark.backgroundColor,
                    // border: theme.button.light.border,
                    color: theme.button.dark.color,
                  },
                }}
                {...a11yProps(i)}
              />
            })
          }
        </Tabs>
      </Box>
      {
        panels.map(({ content }, i) => {
          return <PanelTab
            key={`panelTab_${i}`}
            value={value || 0}
            index={i}
          >
            {content}
          </PanelTab>
        })
      }
    </Box>
  );
}

export default CustomTab